<template>
  <div class="gallery-container">

    <!-- Tab navigation -->
    <div class="row mb-3" v-if="shouldShowTabs">
      <div class="w-auto mx-auto ">
        <b-nav pills align="center" class="tab-gallery-navigation">
          <b-nav-item v-for="tab in availableTabs"
                      :key="tab"
                      :active="activeTab === tab"
                      @click="changeTab(tab)">
            {{ getTabLabel(tab) }}
          </b-nav-item>
        </b-nav>
      </div>
    </div>

    <GalleryBar :title="gallery.name"
                :hasPriceList="hasPriceList"
                @show-price-list="showPriceList"
                v-if="gallery.name"/>


    <div v-if="loading" class="text-center">
      <b-spinner variant="primary" label="Spinning"/>
    </div>
    <div v-else-if="!currentTabData || currentTabData.length === 0">
      No media available
    </div>

    <HorizontalScroller ref="horizontalScroller" v-else
                        :loading="loading"
                        :loading-more="loadingMore"
                        :has-pagination="hasPagination"
                        @load-more="loadMore">
      <div class="col col-fixed" v-for="(media, index) in currentTabData" :key="index">
        <MediaItem :media="media"
                   :index="index"
                   :digital-item-id="digitalItemId"
                   :cart-enabled="activeTab === GALLERY_TAB_TYPE.UNPURCHASED"
                   :gallery="gallery"
                   :favorite-enabled="favoriteEnabled"
                   @toggle-favorite="toggleFavourite(media)"
                   @select="openMedia(index)"/>
      </div>
    </HorizontalScroller>

    <ModalMediaItem :medias="mediaList"
                    :total-medias="activeTabCount"
                    :page="mediaList.length"
                    :pagination-mode="paginationType"
                    :is-paid="activeTab === GALLERY_TAB_TYPE.UNPURCHASED"
                    :gallery-type="gallery.type"
                    :digital-item-id="digitalItemId"
                    :ref="modalMediasGalleryId"
                    :modal-id="modalMediasGalleryId"
                    :gallery="gallery"
                    :favorite-enabled="favoriteEnabled"
                    @add-to-favourites="handleAddToFavourites"
                    @remove-from-favourites="handleRemoveFromFavourites"
                    @load-more="loadMore"/>
  </div>
</template>

<script>
import BaseDisplayType from './BaseDisplayType.vue'
import GalleryBar from "@/domain/galleryTree/components/GalleryBar.vue";
import MediaItem from "@/domain/galleryTree/components/MediaItem.vue";
import {GALLERY_TAB_TYPE_LABELS} from "@/domain/galleryTree/constants/galleryTabType";
import ModalMediaItem from "@/domain/galleryTree/components/ModaMediaItem.vue";
import HorizontalScroller from "@/domain/galleryTree/components/HorizontalScroller.vue";


export default {
  name: 'HorizontalGallery',
  components: {HorizontalScroller, ModalMediaItem, MediaItem, GalleryBar},
  extends: BaseDisplayType,
  computed: {
    displayType() {
      return 'horizontal'
    },

    paginationType() {
      return 'infinite' // Horizontal always uses infinite scroll
    },
    hasTabSupport() {
      return true // Vertical supports tabs
    },
    availableTabs() {
      // Now gallery.tabs is an array of objects with {name, count}
      // Include tabs with count > 0 OR the currently active tab (even if count = 0)
      return (this.gallery.tabs.filter(tab => tab.count > 0 || tab.type === this.activeTab) || []).map(tab => tab.type)
    }
  },
  watch: {
    async loading(newValue) {
      if (!newValue) {
        await this.$nextTick()
        this.$refs.horizontalScroller.init()
      }
    }
  },

  methods: {

    getPaginationSize() {
      return 5 // Horizontal view shows 15 items per page
    },
    getTabLabel(tab) {
      return GALLERY_TAB_TYPE_LABELS[tab] || tab
    },
    toggleFavourite(item) {
      if (item.favorite) {
        this.handleRemoveFromFavourites(item.id)
      } else {
        this.handleAddToFavourites(item.id)
      }
    }

  }
}
</script>